export const aciOneWay = {
    iconName: 'one-way',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                'clip-rule': 'evenodd',
                d: 'M.75 11.894A2.25 2.25 0 003 14.144h12.568L12.515 17.2a2.25 2.25 0 103.185 3.18l6.891-6.895a2.25 2.25 0 000-3.182L15.7 3.409a2.25 2.25 0 00-3.182 3.182l3.05 3.053H3a2.25 2.25 0 00-2.25 2.25z',
                stroke: 'currentColor',
                'stroke-width': '1.5',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
            },
        },
    },
};
